import React, { useState } from "react";
import { handlePostRequest } from "../../services/PostTemplate";
import SearchAccountNumberMpin from "./SearchAccountMpin";
import NewMpin from "./NewMpin";
import AccountInfo from "../../components/accountInfo/AccountInfo";

function MpinResetInquiry() {
    const [step, setStep] = useState("SEARCH");
    const [form1Data, setForm1Data] = useState(null);
    const [accountInfoData, setAccountInfoData] = useState(null);

    const handleReturnData = (data, formData) => {
        setAccountInfoData(data?.data);
        setForm1Data(formData);
        if (data?.data === undefined) {
            setStep("SEARCH");
        }
        else {
            setStep("SET_NEW_MPIN");
        }
    };

    const onVerifyOtp = async (formData, api) => {
        const data = {
            ...formData,
            ...form1Data,
        };
        try {
            await handlePostRequest(data, api);
            setStep("SEARCH");
        } catch (error) {
            console.log(error);
        }
    };

    switch (step) {
        case "SEARCH":
            return <SearchAccountNumberMpin title="MPIN Reset" handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/mpinResetInquiry" />;
        case "SET_NEW_MPIN":
            return (
                <>
                    <SearchAccountNumberMpin title="MPIN Reset" handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/mpinResetInquiry" />
                    <AccountInfo accountInfoData={accountInfoData} />
                    <NewMpin handleReturnData={onVerifyOtp} title="Set New MPIN" mobileNo={form1Data?.MobileNo} />
                </>
            );
        default:
            return null;
    }
}

export default MpinResetInquiry;
